import { FormProps } from '@alphabait/ui/form'

import i18n from '../../i18n'
import { AlphaTypes, EmailInput } from './custom-types'
import style from './form.module.css'

export default function CustomEmail({
  field,
  formProps,
}: {
  field: EmailInput
  formProps: FormProps
}) {
  return (
    <input
      type="email"
      placeholder={field.uiOptions?.placeholder ?? 'email@example.com'}
      className={style.customInput}
      {...formProps?.register(field.name, {
        value: field.value,
      })}
      data-testid={field.uiOptions?.testId}
      disabled={field.uiOptions?.disabled}
    />
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const getCustomEmailProperties = () =>
  [
    {
      name: 'uiOptions.label',
      type: 'input',
      uiOptions: {
        label: i18n.t('questionnaire_builder.question'),
        inputType: 'text',
      },
      validations: ['required'],
    },
    {
      name: 'validation.required',
      customControlType: 'switch',
      type: 'custom',
      uiOptions: {
        label: i18n.t('questionnaire_builder.required'),
      },
    },
  ] as AlphaTypes[]
